export interface DisputImageLineItemT {
    image : string
    notes : string
}

export interface DisputeT {
    id : number | string
    summary : string
    fkCommunications : number | string
    images : Array<DisputImageLineItemT>
    agreements : string
}

export const DisputeObj : DisputeT = {
    id: '',
    summary: '',
    fkCommunications: '',
    images: [],
    agreements : ''
}